import { z } from 'zod';
import { usernameSchema } from "./common.js";
export const platformSchema = z.enum(['chess.com', 'lichess']);
/** One vocabulary for both platforms, so a rule can say "blitz" once (ADR-0014). */
export const timeClassSchema = z.enum(['bullet', 'blitz', 'rapid', 'classical', 'daily']);
export const colorSchema = z.enum(['white', 'black']);
/** Always from the tracked player's side. */
export const gameResultSchema = z.enum(['win', 'draw', 'loss']);
export const trackedPlayerSchema = z.object({
    id: z.string().min(1),
    platform: platformSchema,
    username: z.string().min(1),
    profileUrl: z.url(),
    trackedSince: z.iso.datetime(),
    lastSyncedAt: z.iso.datetime().nullable(),
    /** Why the most recent sync failed; null once a sync succeeds. */
    lastSyncError: z.string().nullable(),
});
export const trackedPlayerListSchema = z.object({
    players: z.array(trackedPlayerSchema),
});
export const trackPlayerRequestSchema = z.object({
    platform: platformSchema,
    username: usernameSchema,
});
export const gameSchema = z.object({
    id: z.string().min(1),
    trackedPlayerId: z.string().min(1),
    platform: platformSchema,
    player: z.string().min(1),
    url: z.url(),
    playedAt: z.iso.datetime(),
    color: colorSchema,
    result: gameResultSchema,
    opponent: z.string().min(1),
    playerRating: z.number().int(),
    opponentRating: z.number().int(),
    timeClass: timeClassSchema,
    rated: z.boolean(),
});
export const MAX_GAMES_LIMIT = 200;
export const gameListQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(MAX_GAMES_LIMIT).default(50),
});
export const gameListSchema = z.object({
    games: z.array(gameSchema),
});
//# sourceMappingURL=games.js.map